import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Play, BookOpen, Wrench } from 'lucide-react';
import api from '../services/api';

const DownloadCenter = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Téléchargements | IPTV4KFR';
    // Évite le double comptage si l'ouverture vient de Nova (déjà loggée)
    const fromNova = sessionStorage.getItem('nova_downloads_source');
    if (fromNova) {
      sessionStorage.removeItem('nova_downloads_source');
    } else {
      api.post('/assistant/page-event', { event: 'downloads_opened', source: 'direct' }).catch(() => {});
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0B]" data-testid="download-center-page">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full h-full"
      >
        {/* Header with branding */}
        <div className="bg-gradient-to-r from-[#FF6B35] to-[#F7931E] py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-white text-center">
              Centre de Téléchargement
            </h1>
            <p className="text-white/90 text-center mt-2">
              Téléchargez les applications nécessaires pour profiter de votre abonnement IPTV
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 mt-4" data-testid="downloads-crosslinks">
              <Link to="/assistance?intent=setup_iptv" className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors" data-testid="downloads-install-with-nova">
                <Play className="h-4 w-4" /> Installer avec Nova
              </Link>
              <Link to="/tutoriels" className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors" data-testid="downloads-open-tutorials">
                <BookOpen className="h-4 w-4" /> Tutoriels et assistance
              </Link>
              <Link to="/assistance" className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors" data-testid="downloads-solve-problem">
                <Wrench className="h-4 w-4" /> Résoudre un problème
              </Link>
            </div>
          </div>
        </div>

        {/* Iframe container - seamless integration */}
        <div className="relative w-full" style={{ height: 'calc(100vh - 180px)', minHeight: '600px' }}>
          <iframe
            src="https://appscenter.xyz/apps"
            title="Centre de Téléchargement IPTV4KFR"
            className="w-full h-full border-0"
            style={{
              display: 'block',
              border: 'none',
              margin: 0,
              padding: 0,
              overflow: 'auto'
            }}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
            loading="lazy"
          />
        </div>

        {/* Footer branding - optional */}
        <div className="bg-[#121214] py-4 border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-[#E8E8E8]/60 text-sm">
              Besoin d'aide ? Consultez nos <a href="/tutoriels" className="text-[#FF6B35] hover:text-[#F7931E]">Tutoriels et assistance</a> ou contactez notre <a href="/faq" className="text-[#FF6B35] hover:text-[#F7931E]">support</a>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DownloadCenter;